module.exports = __webpack_public_path__ + "img/takeLeave_5_zh.27f7dc97.png";